////////LIBRARY/////////
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { map, isUndefined } from 'lodash'
import { useSelector, shallowEqual } from 'react-redux'
///////COMPONENTS///////
import { SelectInputWrapper, SelectInput, OptionCustom } from '../../../theme/GlobalCss'

/////////STYLED/////////
const DropdownWrapper = styled(SelectInputWrapper)`
    justify-content: center;
    align-items: center;
	margin-right:${(props) => (props.marginRight ? `${props.marginRight}px` : null)};
	&::after{
		height:${(props) => (props.heightAfter ? `${props.heightAfter}%` : '')};
		display: ${(props) => (props.displayList ? 'none' : 'block')};a
	}
`
const Label = styled.div`
	margin-right: 10px;
	width: ${(props) => (props.width ? `${props.width}px` : null)};
`
const ListSelect = styled(SelectInput)`
	border: 1px solid ${(props) => props.theme.colors.primary};
	cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
	display: ${(props) => (props.displayList ? 'none' : 'block')};
	color: ${(props) => (props.colorValue > 0 ? props.theme.colors.menu.link : props.theme.colors.eraser)};
`
/////////STYLED/////////

/**
 *
 * @param {string} label
 * @param {Array} list
 * @param {string} listName
 * @param {func} register
 * @param {int} width
 * @param {boolean} displayList
 * @return {*}
 * @constructor
 */
const Dropdown = ({
	label,
	list,
	listName,
	register,
	zeroValue,
	onChangeHandler,
	heightAfter,
	marginRight,
	disabled,
	width,
	displayList,
	target,
}) => {
	const { user } = useSelector(
		(state) => ({
			user: state.user,
		}),
		shallowEqual
	)

	const [value, setValue] = useState()

	///////////////////////////////// HANDLE ///////////////////////////////////////

	const handleGetValue = (e) => {
		setValue(parseInt(e.target.value))
	}

	useEffect(() => {
		if (user?.identity?.idPerimeter != 0) {
			handleGetValue({ target: { value: user?.identity?.idPerimeter } })
		}
	}, [user])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<DropdownWrapper blueColor heightAfter={heightAfter} marginRight={marginRight} displayList={displayList}>
			<Label htmlFor={listName} width={width}>
				{label}
			</Label>
			<ListSelect
				name={listName}
				ref={register}
				onChange={onChangeHandler}
				onClick={(e) => handleGetValue(e)}
				disabled={disabled}
				displayList={displayList}
				colorValue={value} // we pass this props to test if the value are greater than 0, in this case we change the font color
			>
				{!isUndefined(zeroValue) ? (
					<OptionCustom value="0" key={0} hidden>
						{zeroValue}
					</OptionCustom>
				) : (
					''
				)}
				{map(list, (elem, id) => (
					<OptionCustom key={id} value={elem.value} name={elem.id} target={target}>
						{elem.label}
					</OptionCustom>
				))}
			</ListSelect>
		</DropdownWrapper>
	)
}

Dropdown.propTypes = {
	label: PropTypes.string.isRequired,
	list: PropTypes.array.isRequired,
	listName: PropTypes.string.isRequired,
	register: PropTypes.func.isRequired,
}

Dropdown.defaultPropTypes = {
	label: '',
	list: [],
	listName: '',
	// Default prop type => empty function
	register: () => {},
}

export default Dropdown
